import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'; // Import MatDialogRef
import { Router } from '@angular/router';
import { GameControlService } from "./game-service";

@Component({
  selector: 'app-end-game',
  templateUrl: './end-game.component.html',
  styleUrls: ['./end-game.component.scss']
})
export class EndGameComponent {
  
  baseScore?: number;
  timeBonus?: number;
  totalScore: number;
  showLevelScore:boolean=true;
  gameStarted:boolean=true;
  gameEnded:boolean=true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { totalScore?:number, baseScore?: number, timeBonus?: number }, // Add new data fields
    private dialogRef: MatDialogRef<EndGameComponent>, // Specify correct type
    private gameControlService: GameControlService,
    private router: Router
  ) {
    if (data.baseScore !== undefined && data.timeBonus !== undefined) {
      this.baseScore = data.baseScore;
      this.timeBonus = data.timeBonus;
      this.totalScore = this.baseScore + this.timeBonus;
    } else if (data.totalScore !== undefined) {
      this.totalScore = data.totalScore;
    } else {
      console.error('No valid score data provided');
      this.totalScore = 0;
    }
  }
    

  navigateHome(): void {
    this.gameControlService.resetGameState();
    this.dialogRef.close('home');
    this.router.navigate(['games']);
  }

  closeDialog():void{
    this.dialogRef.close('close');
  }
  

  replayGame(): void {
    this.gameControlService.resetGameState();
    this.dialogRef.close('replay');
  }
  ngOnDestroy(){
    this.gameControlService.resetGameState();
  }
}
